<template>
  <div class="thankYou-page">
    <div class="thankYou-pageContent">
      <div class="text-center">
        <h1 class="display-4 mb-4">Signing in...</h1>
        <p class="lead txt--l txt--off-white">
          Hold on a second! we are signing you in to the account...
        </p>
        <hr class="border--bottom-gray border-top-0" />
        <p class="txt--ss">
          Having trouble?
          <a class="txt--primary" href="mailto:hello@piedparker.com?subject=Hello!">Contact us</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      uuid:'',
      token:null,
    }
  },
  created(){
    if(this.$route.query.redirect!='' && this.$route.query.redirect!=undefined && this.$route.query.redirect!=null)
    {
      this.uuid = this.$route.query.redirect ;
      this.adminLogin();
    } 
    else
    {
      this.$toasted.show("Failed to log into the user account!",{
        icon : 'times-circle',
        className : 'error-class'
      });
      this.$nextTick(()=>{
        this.$router.push("/login");
      });
    }
  },
  methods:{
    adminLogin(){
      this.axios.post(window.hostname+'/api/admin/commercial-login',{
        uuid : this.uuid
      })
      .then(res=>{
        // console.log(res.data);
        if(res.data.status)
        {
          if(res.data.access_token!='')
          {
            localStorage.setItem('admin_access',true);
            localStorage.setItem("commercial_token_new",res.data.access_token);
            localStorage.setItem('admin_name',res.data.getToken.admin_name);
            localStorage.setItem('admin_id',res.data.getToken.admin_id);
            localStorage.setItem('admin_hash',res.data.admin_hash);
            localStorage.setItem('admin_email',res.data.admin_email);
            localStorage.setItem('admin_profile_image',res.data.admin_profile_image);
            localStorage.setItem('role', res.data.admin_role);
            this.$router.push({name : 'Welcome'});
          }
          this.$toasted.show(res.data.message,{
            icon:'times-circle',
            className : 'error-class'
          });
          this.$nextTick(()=>{
            this.$router.push("/login");
          });
        }
        else
        {
          this.$toasted.show(res.data.message,{
            icon:'times-circle',
            className : 'error-class'
          });
          this.$nextTick(()=>{
            this.$router.push("/login");
          });
        }
      })
      .catch(err=>{
        this.$toasted.show("Something went wrong. Please try again!",{
          icon : 'times-circle',
          className : 'error-class'
        });
        this.$nextTick(()=>{
          this.$router.push("/login");
        });
      });
    }
  }
}
</script>